import { render, staticRenderFns } from "./GGardenReport.vue?vue&type=template&id=e213ab7e"
import script from "./GGardenReport.vue?vue&type=script&lang=js"
export * from "./GGardenReport.vue?vue&type=script&lang=js"
import style0 from "./GGardenReport.vue?vue&type=style&index=0&id=e213ab7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports